import type { SearchCriteria } from '@/entities/searchCriteria';
import { SERP_APP_INSTALL_BANNER_TEXTS } from '../config/texts';

export function getAppInstallDirectionName(destination: SearchCriteria['destination']): string {
  if (!destination || destination.kind === 'none') return '';
  if (destination.kind === 'resorts' && destination.resorts.length === 1) return destination.resorts[0]!.name;

  return destination.country.name;
}

export function getAppInstallBannerTitle(criteria: SearchCriteria): string {
  const direction = getAppInstallDirectionName(criteria.destination);

  return direction
    ? `${direction}: ${SERP_APP_INSTALL_BANNER_TEXTS.title}`
    : SERP_APP_INSTALL_BANNER_TEXTS.fallbackTitle;
}
